import styled from "styled-components";
import { palette, size } from "styled-theme";

function getLineHeight(props) {
  if (props.size === "p0") {
    return "19px";
  }
  return "16px";
}

export const Paragraph = styled.p`
  font-size: ${props => size(props.size ?? "p2")};
  color: ${palette("color", 17)};
  line-height: ${props => getLineHeight(props)};
  text-align: ${props => props.textAlign ?? "initial"}
  
  &:not(:last-child)  {
    padding-bottom: 20px;
  }
`;
